import React, { HTMLAttributes } from 'react'
import classNames from 'classnames'
import './index.less'

type SJButtonProps = HTMLAttributes<HTMLDivElement> & {
  type?: 'default' | 'primary' | 'plain' | 'danger'
  size?: 'mini' | 'small' | 'normal' | 'large'
  disabled?: boolean
  onClick?: (e: any) => void
  children: React.ReactNode
}

const SJButton: React.FC<SJButtonProps> = ({
  className,
  type = 'default',
  size = 'normal',
  disabled = false,
  children,
  onClick,
  ...props
}) => {
  return (
    <div
      className={classNames(
        className,
        'sj-button',
        `sj-button-${type}`,
        `sj-button_${size}`,
        disabled ? 'sj-button-disabled' : '',
      )}
      onClick={disabled ? undefined : onClick}
      {...props}
    >
      <span>{children}</span>
    </div>
  )
}

export default SJButton
